import { prop } from "@messaia/cdk";

export class ProductDetails {
    @prop()
    bandwidth: number;

    @prop()
    downloadSpeed: number | null;

    @prop()
    minDownloadSpeed: number | null;

    @prop()
    maxDownloadSpeed: number | null;

    @prop()
    uploadSpeed: number | null;

    @prop()
    minUploadSpeed: number | null;

    @prop()
    maxUploadSpeed: number | null;
}